import { GameScene } from '../../GameScene';
import {
  ICollision,
  CollideHandler,
} from '../../actions/collisions/ICollision';
import { InvalidEffect } from '../../actions/effects/InvalidEffect';
import { CollideId, CollideEvent, isOneHitCollider } from '../../defs/collide';
import {
  despawnBlockEntity,
  setBlockEntityViewLayer,
} from '../../entities/BlockEntity';
import { MagicBunniesBlockEffect } from './MagicBunniesBlockEffect';
import { MagicBunniesBlockEntity } from './MagicBunniesBlockEntity';
import gsap from 'gsap';

// The duration for the hit animation, during which the block is brought to the front
const HIT_ANIMATION_DURATION = 0.8;

export class MagicBunniesBlockCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: MagicBunniesBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: MagicBunniesBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    await this.hit(event);
    return true;
  }

  private async resolveAttack(event: CollideEvent) {
    await this.hit(event);
    return true;
  }

  private async hit(event: CollideEvent) {
    const magicBunnies = this.entity.c.blockMagicBunnies;
    magicBunnies.gotHit = true;

    if (magicBunnies.count > 1 && !isOneHitCollider(event.collider?.type)) {
      magicBunnies.count -= 1;
      // Briefly bring the block to the front while animation plays
      setBlockEntityViewLayer(this.scene, this.entity, 'middle');
      await gsap.to({}, { duration: HIT_ANIMATION_DURATION });
      setBlockEntityViewLayer(this.scene, this.entity, 'default');
    } else {
      const effect = new MagicBunniesBlockEffect(this.scene);
      await effect.playClearAnimation(this.entity);
      despawnBlockEntity(this.scene, this.entity);
    }
  }
}
